webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navigation__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Navigation__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('navbar', __WEBPACK_IMPORTED_MODULE_1__Navigation___default.a);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_News__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_News___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_News__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Home',
        jQuery: __WEBPACK_IMPORTED_MODULE_5_jquery___default.a,
        component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a
    }]
}));

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(29),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_marked__);





__webpack_require__(4);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    marked: __WEBPACK_IMPORTED_MODULE_3_marked___default.a,
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
    }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app'
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'hello',
    data: function data() {
        return {
            msg: 'Welcome to Your Vue.js App'
        };
    }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var jQuery = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        var _this = this;

        jQuery(document).mousemove(function (event) {
            _this.mouseMove(event.pageX, event.pageY);
        });
    },
    data: function data() {
        return {};
    },

    methods: {
        mouseMove: function mouseMove(mouseX, mouseY) {
            var logo = jQuery('.parallax');
            var offset = logo.offset();

            var centerX = offset.left + logo.width() / 2;
            var centerY = offset.top + logo.height() / 2;

            var deltaX = mouseX - centerX;
            var deltaY = mouseY - centerY;

            var rotateX = deltaX / jQuery(window).width() * 45;
            var rotateY = deltaY / jQuery(window).height() * 45;

            if (rotateX < 0) {
                rotateX = 360 + rotateX;
            }

            if (rotateY < 0) {
                rotateY = 360 + rotateY;
            }

            logo.css('transform', 'rotate3d(1, 0, 0, ' + -rotateY + 'deg) rotate3d(0, 1, 0, ' + rotateX + 'deg)');
        }
    }
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'news',
    data: function data() {
        return {
            entries: [{
                author: {
                    name: 'Shinynecrid',
                    avatar: 'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/a9/a97ee555e1e1b1dab04258b26e1a858e5db0e7dc_full.jpg'
                },
                title: 'Factorio!',
                date: '25 Apr 2017',
                content: '<p>We are hosting a Factorio server based on the latest Beta Release! Feel free to join us on 198.23.156.34(Server IP) and in discord!</p><p><a href="https://discord.gg/0140zAqXoEaHJKmnX">https://discord.gg/0140zAqXoEaHJKmnX</a></p><p>Any questions let myself or another staff member know!</p>'
            }, {
                author: {
                    name: 'SilentSymphony',
                    avatar: 'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/96/96485033c7c2eca148376e1be3694c2f9c97ff1c_full.jpg'
                },
                title: 'We\'re now officially supporting Avorion',
                date: '01 Apr 2017',
                content: '<p>I’m happy to announce that we’ll be supporting the space builder game Avorion with our new server The Verse!</p><p>Game Page: <a href="http://store.steampowered.com/app/445220/">http://store.steampowered.com/app/445220/</a></p><p>This game has very good ship building capabilities, which after over a month of play im still finding new ways to use it - you could build a flying shoe!</p><p>It also allows for a diverse styles of play to meet your goals and progress through the game such as scavenging, pirating, mining, hauling cargo and more options and even more to come in future patches!</p><p>We hope to see you on the server and the discord!</p><p>Server IP: <a href="http://theverse.ubrgmg.com">theverse.ubrgmg.com</a><br>Discord: <a href="https://discord.gg/0140zAqXoEaHJKmnX">https://discord.gg/0140zAqXoEaHJKmnX</a></p>'
            }, {
                author: {
                    name: 'SilentSymphony',
                    avatar: 'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/96/96485033c7c2eca148376e1be3694c2f9c97ff1c_full.jpg'
                },
                title: 'Sector Zero: Status Update',
                date: '01 Apr 2017',
                content: '<p>As im sure most of you know the development branch has finally been removed from the game and we are now all on a default branch again, If you have not already be sure to go into your SE’s beta tab and switch back to the normal version of space engineers.</p><p>Notes for that update are here: <a href="https://forums.keenswh.com/threads/update-01-178-3-minor-dead-drop-arena-new-update-release-system.7393571/">https://forums.keenswh.com/threads/update-01-178-3-minor-dead-drop-arena-new-update-release-system.7393571/</a></p><p>It’s been a little over 3 years of Sector Zero being online and i have no intention of stopping here after all this time, The new server software Torch seems to be coming along nicely and when its ready we’ll be switching to it, If you guys see Rexxar, Jimmacle be sure to thank them without their efforts we wouldnt still be here!</p><p>Remember to drop by our Discord <a href="https://discord.gg/0140zAqXoEaHJKmnX">https://discord.gg/0140zAqXoEaHJKmnX</a> as it is our central communications hub, if you need support, want to suggest changes, or just want to chat feel free to drop in and make yourself at home.</p>'
            }]
        };
    },
    methods: function methods() {}
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAFbCAYAAAD825PCAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4QUHFi0ZGBH4owAAAyVJREFUeNrt3bENgDAQBME/+u/5KICEAEvGmmkA8fbqQ6ftnCLJ73+mbZyFs/jaNcDxhA5CB4QOCB0QOiB0QOiA0AGhg9ABoQNCB4QOCB0QOiB0QOggdEDogNABoQNCB4QOCB0QOgjdCEDogNABoQNCB4QOCB0QOiB0EDogdEDogNABoQNCB4QOCB2EDggdEDogdEDowEJpawpgowNCB4QOCB0QOiB0QOiA0EHogNABoQNCB4QOCB0QOiB0EDogdEDogNABoQNCB4QOCB2EDpwtM+OplpfaxhQ2uryJu2ujA0IHoQNCB4QOCB0QOiB0QOiA0EHogNABoQNCB4QOCB0QOiB0EDogdEDogNABoQNCB4QOCB0QOggdEDogdEDogNABoQNCB4QOQgeEDggdEDogdEDogNABoYPQAaEDQgeEDggdEDogdEDogNBB6IDQAaEDQgeEDggdEDogdBA6IHRA6IDQAaEDQgeEDggdhA4IHRA6IHRA6IDQAaEDQgeEDkIHhA4IHRA6IHRA6IDQAaGD0AGhA0IHhA4IHRA6IHRA6CB0QOiA0AGhA0IHhA4IHRA6IHQQOiB0QOiA0AGhA0IHhA4IHYQOCB0QOiB0QOiA0AGhA0IHoQNCB4QOCB0QOiB0QOiA0AGhg9ABoQNCB4QOCB0QOiB0QOggdEDogNABoQNCB4QOCB0QOggdEDogdEDogNABoQNCB4QOCB2EDggdEDogdEDogNABoQNCB6EDQgeEDggdEDogdEDogNBB6IDQAaEDQgeEDggdEDogdEDoIHRA6IDQAaEDQgeEDggdEDoIHRA6IHRA6IDQAaEDQgeEDkIHhA4IHdhYZqbGADY6IHRA6IDQAaEDQgeEDggdhA4IHRA6IHRA6IDQAaEDQgehA0IHhA4IHRA6IHRA6IDQQeiA0AGhA0IHhA4IHRA6IHRA6CB0QOiA0AGhA0IHhA4IHRA6CB0QOiB0QOiA0AGhA0IHhA5CB06Wtms/kNSY4altbHRA6IDQAaGD0AGhA0IHhA4IHRA6IHRA6CB0QOiA0AGhA0IHhA4IHRA6IHQQOiB04BdukvUdp3SQTPQAAAAASUVORK5CYII="

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(30),
  /* scopeId */
  "data-v-71574527",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(16)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(28),
  /* scopeId */
  "data-v-2660219a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(19)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(31),
  /* scopeId */
  "data-v-bd3ee3e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(20)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(32),
  /* scopeId */
  "data-v-d302c4e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "splash"
  }, [_c('div', {
    staticClass: "parallax"
  }, [_c('div', {
    staticClass: "logo back"
  }), _vm._v(" "), _c('div', {
    staticClass: "logo front"
  })]), _vm._v(" "), _c('div', {
    staticClass: "h2"
  }, [_c('div', {
    staticClass: "inset bg-alt text-bg"
  }, [_vm._v("Ubercharged Gaming")])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("Coming soon™")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://discord.gg/0140zAqXoEaHJKmnX"
    }
  }, [_vm._v("Discord")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://steamcommunity.com/groups/ubrgmg"
    }
  }, [_vm._v("Steam")])])])])
}]}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("News")])], 1), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "brand"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "30px",
      "height": "42px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "marker"
  }, [_vm._v("beta")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Events")])])
}]}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "h1 header"
  }, [_vm._v("News & Announcements")]), _vm._v(" "), _vm._l((_vm.entries), function(entry) {
    return _c('div', {
      staticClass: "entry"
    }, [_c('ul', {
      staticClass: "inline nospace small-text text-muted",
      staticStyle: {
        "margin-bottom": "4px"
      }
    }, [_c('li', [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": entry.author.avatar,
        "width": "28px",
        "height": "28px"
      }
    })]), _vm._v(" "), _c('li', [_vm._v(_vm._s(entry.author.name))]), _vm._v(" "), _c('li', [_vm._v("•")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(entry.date))])]), _vm._v(" "), _c('div', {
      staticClass: "h2"
    }, [_vm._v(_vm._s(entry.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(entry.content)
      }
    }), _vm._v(" "), _c('hr')])
  })], 2)])
},staticRenderFns: []}

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.8659ca92bbdbf90a163f.js